import { PlayersView } from './players';
import { ServiceLocations, CstLocationNotes } from '../../../../shared/api-models/admin';

export class LocationsTicketEdit extends ServiceLocations {
    players: PlayersView[];
    showPlayerBox: boolean;
    cstLocationNote: CstLocationNotes;
}